import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Sidebar } from 'src/app/shared';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {
  env_url = environment;
  constructor( public _sidebar: Sidebar, ) { }

  ngOnInit() {
  }

}
